// extracted by mini-css-extract-plugin
export default {"main":"WebviewPage_main__+909K","loader":"WebviewPage_loader__NQR-d","loaderText":"WebviewPage_loaderText__4US3i","error":"WebviewPage_error__zpusm"};